module.exports = __webpack_public_path__ + "img/oldOne.79a761d5.png";